import styled from 'styled-components';

export const MenuArea = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0);
  min-width: 250px;
  top: 0px;
  right: 12px;
  z-index: 999;
  max-height: 100%;
  overflow: auto;
`;
